import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    Label,
    Input,
    FormGroup,
    Form,
    Col,
    Fade
} from 'reactstrap';
import Switch from "react-switch";
import FormWrapper from './../../commonComponents/formWrapper/FormWrapper.container';
import './ApproveConsentAfterRequest.css';
import _ from 'lodash';
import {REFUSE_REASONS, AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST} from './../../../constants/constants';
import {Utils} from './../../../utils/utils';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import PeriodSelect from "../periodSelect/PeriodSelect.container";
import {GRANTED, REJECTED} from "../../../reducers/consent/consents";
import moment from "moment/moment";
import ApproveConsentProgressBar from '../../commonComponents/progressBar/ApproveConsentProgressBar.container';
import {Redirect} from 'react-router-dom';
import BackButtonComponent from "../../commonComponents/backButtonComponent/BackButtonComponent";
import Select from "../../commonComponents/customSelect/CustomSelect.container";

const MAX_PERIOD = moment.duration(3, AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST.MONTH).add(1, 'day');
const MIN_PERIOD = moment.duration(1, AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST.WEEK).subtract(1, 'day');
const DEFAULT_PERIOD_TYPE = AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST.MONTH;
const DEFAULT_PERIOD_NUM = '1';

class ApproveConsentAfterRequest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reason: "",
            message: "",
            isGrant: true,
            periodType: DEFAULT_PERIOD_TYPE,
            periodNum: DEFAULT_PERIOD_NUM
        };
    }

    componentWillMount() {
        if (!_.isNil(this.props.id)) {
            this.props.onLoadConsent(this.props.id);
        }
    }

    componentWillUpdate(nextProps) {
        if (this.props.id !== nextProps.id && !_.isNil(nextProps.id)) {
            this.props.onLoadConsent(nextProps.id);
        }
    }

    render() {
        if (!this.props.loading && _.isNil(this.props.id)) {
            return <Redirect to='/pending-consents'/>;
        }

        return (
            <div className="approve-consent-after-request-container">
                <FormWrapper
                    successMessage={_.get(this.props.translation, 'approve_consent_after_request.success_alert')}
                >
                    <BackButtonComponent path="/pending-consents" label={_.get(this.props.translation, sharedLabelsPath.back_button)}/>
                    <div className="approve-consent-after-request-form">
                        <h4 className="text-center">{_.get(this.props.translation, 'approve_consent_after_request.label')}</h4>
                        <ApproveConsentProgressBar label={_.get(this.props.translation, 'approve_consent_after_request.approve_consent_progress_label') + ":"}/>
                        {this.renderContent()}
                    </div>
                </FormWrapper>
            </div>
        );
    }

    renderContent = () => {
        if (this.props.loading) {
            return (
                <div className="pending-consents-list-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }

        if (_.isNil(this.props.data)) {
            return null;
        }

        return (
            <Form onSubmit={this.onSubmit}>
                <div className="next-consent-container">
                    <Button className="next-consent-button" color="link"
                            onClick={this.props.onNext}>
                        {_.get(this.props.translation, 'consents.next_consent_button')}
                    </Button>
                </div>
                <FormGroup row>
                    <Col sm={6}>
                        <h5 className="consent-requestor-label">{_.get(this.props.translation, 'approve_consent_after_request.consent_requestor_label')}</h5>
                        {this.getConsentRequestorFormGroups()}
                    </Col>

                    <Col sm={6}>
                        <FormGroup>
                            <Label className="decision-switch-container">
                                <h5 className={this.state.isGrant ? "olive-green" : null}>{_.get(this.props.translation, 'approve_consent_after_request.grant_title_label')}</h5>
                                <Switch
                                    checked={!this.state.isGrant}
                                    onChange={this.toggleDecision}
                                    onColor="#888888"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    className="decision-switcher"
                                />
                                <h5 className={!this.state.isGrant ? "carrot-red" : null}>{_.get(this.props.translation, 'approve_consent_after_request.refuse_title_label')}</h5>
                            </Label>
                            <Fade key="grant" in={this.state.isGrant}>
                                <div className="tab-pane-container" hidden={!this.state.isGrant}>
                                    {this.renderGrantFormGroup()}
                                    <div className="buttons-group">
                                        <Button type="submit" className="olive-green-btn">
                                            {_.get(this.props.translation, 'approve_consent_after_request.grant_button')}
                                        </Button>
                                    </div>
                                </div>
                            </Fade>
                            <Fade key="refuse" in={!this.state.isGrant}>
                                <div className="tab-pane-container" hidden={this.state.isGrant}>
                                    {this.renderRefuseFormGroup()}
                                    <div className="buttons-group">
                                        <Button type="submit" className="carrot-red-btn">
                                            {_.get(this.props.translation, 'approve_consent_after_request.refuse_button')}
                                        </Button>
                                    </div>
                                </div>
                            </Fade>
                        </FormGroup>
                    </Col>
                </FormGroup>
            </Form>
        );
    };


    toggleDecision = () => {
        this.setState({isGrant: !this.state.isGrant})
    };

    getConsentRequestorFormGroups = () => {
        let paramsList = [
            {
                value: !_.isNil(this.props.data.email) ? (<a href={"mailto:" + this.props.data.email}>{this.props.data.email}</a>) : null,
                title: _.get(this.props.translation, sharedLabelsPath.email_label)
            },
            // {
            //     value: "firstName",
            //     title: _.get(this.props.translation, sharedLabelsPath.first_name_label)
            // },
            // {
            //     value: "lastName",
            //     title: _.get(this.props.translation, sharedLabelsPath.last_name_label)
            // },
            {
                value: this.props.data.companyName + ", " + _.get(this.props.translation, 'countries.' + this.props.data.companyCountry),
                title: _.get(this.props.translation, sharedLabelsPath.company_label)
            },
            {
                value: this.props.data.job,
                title: _.get(this.props.translation, 'consents.job_label')
            },
            // {
            //     value: "companyCountry",
            //     title: _.get(this.props.translation, 'approve_consent_after_request.company_country_label')
            // },
            // {
            //     value: "companyDomain",
            //     title: _.get(this.props.translation, sharedLabelsPath.company_domain_label)
            // },
            {
                value: this.props.data.message,
                title: _.get(this.props.translation, 'consents.note_to_applicants_label')
            }
        ];

        if (!(_.isNil(this.props.data.firstName) && _.isNil(this.props.data.lastName))) {
            paramsList.push({
                value: this.props.data.firstName + ' ' + this.props.data.lastName,
                title: _.get(this.props.translation, 'request_credentials_verification.manager_label'),
            })
        }

        paramsList.push({
            value: moment(this.props.data.requestDate).format('L'),
            title: _.get(this.props.translation, 'approve_consent_after_request.request_date'),
        });

        return [..._.map(paramsList, this.getReadOnlyFormGroup)];
    };

    getReadOnlyFormGroup = (params) => {
        if (_.isNil(params.value)) {
            return null;
        }

        return (
            <FormGroup row key={params.title}>
                <Col sm={3}>
                    <h6>{params.title}</h6>
                </Col>
                <Col sm={9}>
                    <Label>{params.value}</Label>
                </Col>
            </FormGroup>
        );
    };

    renderGrantFormGroup = () => {
        if (!this.state.isGrant) {
            return null;
        }

        return [this.renderPeriodFormGroup(), this.getCommentFormGroup()];
    };

    renderPeriodFormGroup = () => {
        return (
            <FormGroup row key="period_label">
                <Label
                    sm={2}>{_.get(this.props.translation, 'approve_consent_after_request.period_label') + "*"}</Label>
                <Col sm={10}>
                    <PeriodSelect
                        id='approve-consent-after-request-period-select'
                        showPopover
                        placement='top'
                        periodEndDateMessage={
                            _.get(this.props.translation, 'consents.consent_end_date_alert') + ' ' + moment().add(this.state.periodNum, this.state.periodType).format('LL')
                        }
                        onPeriodNumChange={this.handlePeriodNumChange}
                        onPeriodTypeChange={this.handlePeriodTypeChange}
                        periodType={this.state.periodType}
                        periodNum={this.state.periodNum}
                    />
                </Col>
            </FormGroup>
        );
    };

    handlePeriodNumChange = (nextPeriodNum) => {
        if (moment().add(nextPeriodNum, this.state.periodType).subtract(MAX_PERIOD).isBefore(moment())
            && moment().add(nextPeriodNum, this.state.periodType).subtract(MIN_PERIOD).isAfter(moment())) {
            this.setState({periodNum: nextPeriodNum});
        }
    };

    handlePeriodTypeChange = (nextPeriodType) => {
        let nextPeriodNum = this.state.periodNum;
        if (!(moment().add(this.state.periodNum, nextPeriodType).subtract(MAX_PERIOD).isBefore(moment())
            && moment().add(this.state.periodNum, nextPeriodType).subtract(MIN_PERIOD).isAfter(moment()))) {
            nextPeriodNum = DEFAULT_PERIOD_NUM;
        }
        this.setState({
            periodType: nextPeriodType,
            periodNum: nextPeriodNum
        });
    };

    renderRefuseFormGroup = () => {
        if (this.state.isGrant) {
            return null;
        }
        let paramsList = [
            {
                value: "reason",
                title: _.get(this.props.translation, 'approve_consent_after_request.reason_label'),
                type: 'select',
                onChange: this.handleChangeSelect("reason"),
                content: Utils.getOptions(
                    _.map(REFUSE_REASONS, value => ({
                        code: value,
                        name: _.get(this.props.translation, 'approve_consent_after_request.reasons.' + value)
                    }))),
                placeholder:_.get(this.props.translation, 'approve_consent_after_request.reason_input_placeholder')
            }
        ];

        return [..._.map(paramsList, this.getFormGroup), this.getCommentFormGroup()];
    };

    getCommentFormGroup = () => {
        return (
            <FormGroup key="comment_for_requestor">
                <Label>{_.get(this.props.translation, 'approve_consent_after_request.comment_label')}</Label>
                <Input type="textarea"
                       value={this.state.message}
                       onChange={this.handleChange("message")}
                       placeholder={_.get(this.props.translation, 'approve_consent_after_request.comment_placeholder')}
                />
            </FormGroup>
        );
    };

    getFormGroup = (params) => {
        if (params.type === 'select') {
            return this.getSelectFormGroup(params);
        }
        if (!params || typeof (params) !== 'object') {
            return;
        }
        if (params.hidden) {
            return null;
        }
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                <Label for={id} sm={2}>{params.title}</Label>
                <Col sm={10}>
                    <Input type={params.type || 'text'} id={id}
                           value={this.state[params.value]}
                           onChange={this.handleChange(params.value)}
                           placeholder={params.placeholder}
                           required={params.isRequired}
                           className={params.className}
                    >
                        {params.content}
                    </Input>
                </Col>
            </FormGroup>
        );
    };

    getSelectFormGroup = (params) => {
        if (!params || typeof (params) !== 'object') {
            return;
        }
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                <Label for={id} sm={3}>{params.title + (params.isRequired ? '*' : '')}</Label>
                <Col sm={9}>
                    <Select id={id}
                            selectedOption={_.find(params.content, option => option.value === this.state[params.value])}
                            options={params.content}
                            onSelect={params.onChange}
                            placeholder={params.placeholder}
                            disabled={params.isDisabled}
                    />
                </Col>
            </FormGroup>
        );
    };

    handleChange = (fieldName) => (e) => {
        this.setState({[fieldName]: e.target.value});
    };

    handleChangeSelect = (fieldKey) => (selectedOption) => {
        this.setState({[fieldKey]: selectedOption.value});
    };


    onSubmit = (e) => {
        e.preventDefault();
        if (this.state.isGrant) {
            let data = {
                status: GRANTED,
                grantedTill: moment().endOf('day').add(this.state.periodNum, this.state.periodType)
            };

            if (this.state.message !== "") {
                data.responseComment = this.state.message;
            }

            this.props.onGrantRequest(this.props.id, data);

        } else {
            let data = {
                status: REJECTED
            };

            if (this.state.reason !== ""){
                data.responseComment = _.get(this.props.translation, 'approve_consent_after_request.reasons.' + this.state.reason) + '. ';
            }
            if (this.state.message !== "") {
                data.responseComment = data.responseComment ? (data.responseComment + this.state.message) : this.state.message;
            }

            this.props.onRefuseRequest(this.props.id, data);
        }
    };
}

ApproveConsentAfterRequest.propTypes = {
    id: PropTypes.string,
    data: PropTypes.object,
    translation: PropTypes.object.isRequired,
    onLoadConsent: PropTypes.func.isRequired,
    onGrantRequest: PropTypes.func.isRequired,
    onRefuseRequest: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired
};

export default ApproveConsentAfterRequest;



// WEBPACK FOOTER //
// ./src/components/consentManagement/approveConsentAfterRequest/ApproveConsentAfterRequest.js